// @ts-nocheck
import { createAsyncThunk } from '@reduxjs/toolkit';

export const initEnvironnement = createAsyncThunk(
  'initEnvironnement',
  async (
    data,
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    const environnement = {
      isCrm:
        import.meta.env.VITE_CRM_URL === import.meta.env.VITE_CURRENT_FRONT_URL,
      isCustomerArea:
        import.meta.env.VITE_CUSTOMER_AREA_URL ===
        import.meta.env.VITE_CURRENT_FRONT_URL,
    };

    return environnement;
  }
);

export default initEnvironnement;
